/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationUser } from './ApplicationUser';
import {
    ApplicationUserFromJSON,
    ApplicationUserFromJSONTyped,
    ApplicationUserToJSON,
    ApplicationUserToJSONTyped,
} from './ApplicationUser';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';
import type { Category } from './Category';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
    CategoryToJSONTyped,
} from './Category';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
    InvoiceToJSONTyped,
} from './Invoice';
import type { OrderLabel } from './OrderLabel';
import {
    OrderLabelFromJSON,
    OrderLabelFromJSONTyped,
    OrderLabelToJSON,
    OrderLabelToJSONTyped,
} from './OrderLabel';
import type { BusinessUnit } from './BusinessUnit';
import {
    BusinessUnitFromJSON,
    BusinessUnitFromJSONTyped,
    BusinessUnitToJSON,
    BusinessUnitToJSONTyped,
} from './BusinessUnit';
import type { FileUpload } from './FileUpload';
import {
    FileUploadFromJSON,
    FileUploadFromJSONTyped,
    FileUploadToJSON,
    FileUploadToJSONTyped,
} from './FileUpload';
import type { Workbook } from './Workbook';
import {
    WorkbookFromJSON,
    WorkbookFromJSONTyped,
    WorkbookToJSON,
    WorkbookToJSONTyped,
} from './Workbook';

/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Organization
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Organization
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Organization
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    name?: string | null;
    /**
     * 
     * @type {Array<ApplicationUser>}
     * @memberof Organization
     */
    users?: Array<ApplicationUser> | null;
    /**
     * 
     * @type {Array<Company>}
     * @memberof Organization
     */
    companies?: Array<Company> | null;
    /**
     * 
     * @type {Array<Order>}
     * @memberof Organization
     */
    orders?: Array<Order> | null;
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof Organization
     */
    invoices?: Array<Invoice> | null;
    /**
     * 
     * @type {Array<BusinessUnit>}
     * @memberof Organization
     */
    businessUnits?: Array<BusinessUnit> | null;
    /**
     * 
     * @type {Array<Category>}
     * @memberof Organization
     */
    categories?: Array<Category> | null;
    /**
     * 
     * @type {Array<ImportSession>}
     * @memberof Organization
     */
    importSessions?: Array<ImportSession> | null;
    /**
     * 
     * @type {Array<FileUpload>}
     * @memberof Organization
     */
    fileUploads?: Array<FileUpload> | null;
    /**
     * 
     * @type {Array<Workbook>}
     * @memberof Organization
     */
    workbooks?: Array<Workbook> | null;
    /**
     * 
     * @type {Array<OrderLabel>}
     * @memberof Organization
     */
    orderLabels?: Array<OrderLabel> | null;
}

/**
 * Check if a given object implements the Organization interface.
 */
export function instanceOfOrganization(value: object): value is Organization {
    return true;
}

export function OrganizationFromJSON(json: any): Organization {
    return OrganizationFromJSONTyped(json, false);
}

export function OrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'name': json['name'] == null ? undefined : json['name'],
        'users': json['users'] == null ? undefined : ((json['users'] as Array<any>).map(ApplicationUserFromJSON)),
        'companies': json['companies'] == null ? undefined : ((json['companies'] as Array<any>).map(CompanyFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderFromJSON)),
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(InvoiceFromJSON)),
        'businessUnits': json['businessUnits'] == null ? undefined : ((json['businessUnits'] as Array<any>).map(BusinessUnitFromJSON)),
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(CategoryFromJSON)),
        'importSessions': json['importSessions'] == null ? undefined : ((json['importSessions'] as Array<any>).map(ImportSessionFromJSON)),
        'fileUploads': json['fileUploads'] == null ? undefined : ((json['fileUploads'] as Array<any>).map(FileUploadFromJSON)),
        'workbooks': json['workbooks'] == null ? undefined : ((json['workbooks'] as Array<any>).map(WorkbookFromJSON)),
        'orderLabels': json['orderLabels'] == null ? undefined : ((json['orderLabels'] as Array<any>).map(OrderLabelFromJSON)),
    };
}

export function OrganizationToJSON(json: any): Organization {
    return OrganizationToJSONTyped(json, false);
}

export function OrganizationToJSONTyped(value?: Organization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'name': value['name'],
        'users': value['users'] == null ? undefined : ((value['users'] as Array<any>).map(ApplicationUserToJSON)),
        'companies': value['companies'] == null ? undefined : ((value['companies'] as Array<any>).map(CompanyToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderToJSON)),
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(InvoiceToJSON)),
        'businessUnits': value['businessUnits'] == null ? undefined : ((value['businessUnits'] as Array<any>).map(BusinessUnitToJSON)),
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(CategoryToJSON)),
        'importSessions': value['importSessions'] == null ? undefined : ((value['importSessions'] as Array<any>).map(ImportSessionToJSON)),
        'fileUploads': value['fileUploads'] == null ? undefined : ((value['fileUploads'] as Array<any>).map(FileUploadToJSON)),
        'workbooks': value['workbooks'] == null ? undefined : ((value['workbooks'] as Array<any>).map(WorkbookToJSON)),
        'orderLabels': value['orderLabels'] == null ? undefined : ((value['orderLabels'] as Array<any>).map(OrderLabelToJSON)),
    };
}

